<template>
	<div class="em-g p-20 bg-white rad-10 mt-20 b-shaddow-5">
		<header class="fs-18 c-black mb-10">{{ $t('Package.myPackages') }}</header>
		<div v-if="loading" class="page-loading">
			<Loading />
		</div>
		<div v-else-if="error" class="not-found-container">
			<NotFoundContent :message="errorMessage" />
		</div>
		<div v-else class="page-content d-flex space-between">
			<div class="chart-container d-flex align-center">
				<canvas id="doughnut-chart"></canvas>
			</div>
			<div class="package-info p-20">
				<ul class="package-details">
					<li class="mb-10"><strong>{{ $t('Package.numberOfDaysUnpack') }}:</strong> {{ packageDays }}</li>
					<li class="mb-10"><strong>{{ $t('Package.numberOfDaysRemaining') }}:</strong> {{ calculatedRemainingDays }}</li>
					<li class="mb-10"><strong>{{ $t('Package.startedDate') }}:</strong> {{ startDate }}</li>
					<li class="mb-10"><strong>{{ $t('Package.endDate') }}:</strong> {{ endDate }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { Chart, DoughnutController, ArcElement, Tooltip, Legend } from 'chart.js';
import Loading from '@/components/user/layout/LoadingComponent.vue'
import NotFoundContent from '@/components/user/common/NotFoundContent.vue'; 
import { getActiveUserPackage } from '@/api/user.api';

Chart.register(DoughnutController, ArcElement, Tooltip, Legend);

export default {
	name: 'MyPackageComponentVue',
	components: {
		Loading,
		NotFoundContent
	},
	data() {
		return {
			packageData: null,
			packageDays: 0,
			remainingDays: 0,
			startDate: '',
			endDate: '',
			chart: null,
			loading: false,
			error: false,
			errorMessage: '',
		};
	},
	computed: {
		calculatedRemainingDays() {
			const endDate = new Date(this.endDate);
			const now = new Date();
			const timeDiff = endDate - now;
			const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
			return daysDiff > 0 ? daysDiff : 0;
		}
	},
	watch: {
		endDate() {
			if (this.endDate) {
				this.$nextTick(() => {
					this.renderChart();
				});
			}
		},
		packageData(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.$nextTick(() => {
					this.renderChart();
				});
			}
		}
	},
	mounted() {
		this.myPackage();
	},
	methods: {
		async myPackage() {
			this.loading = true;
			try {
				const response = await getActiveUserPackage();
				if (response.data.errNum == 200) {
					const packageData = response.data.data;
					this.packageDays = packageData.package.days;
					this.startDate = packageData.startedDate;
					this.endDate = packageData.endDate;
				} else {
					this.error = true;
					this.errorMessage = response.data.msg || 'No package data available.';
				}
			} catch (error) {
				this.error = true;
				this.errorMessage = response.data.msg ;
			} finally {
				this.loading = false;
			}
		},
		renderChart() {
			const ctx = document.getElementById('doughnut-chart').getContext('2d');
			if (ctx && this.endDate) { // Check if context and endDate are available
				if (this.chart) {
					this.chart.destroy();
				}
				this.chart = new Chart(ctx, {
					type: 'doughnut',
					data: {
						labels: ['Days Passed', 'Days Remaining'],
						datasets: [{
							label: 'Package Days',
							backgroundColor: ['#FF0000', '#000055'],
							data: [this.packageDays - this.calculatedRemainingDays, this.calculatedRemainingDays],
							borderWidth: 1,
							hoverBorderWidth: 1
						}]
					},
					options: {
						responsive: true,
						maintainAspectRatio: false,
						cutout: '70%',
						plugins: {
							legend: {
								display: true,
								position: 'hidden'
							}
						}
					}
				});
			}
		}
	}
};
</script>

<style>
.em-g {
	margin-top: 10px !important;
}
.chart-container {
	flex: 1;
	position: relative;
	height: 150px;
	width: 150px;
}

.package-info {
	flex: 2;
	padding-left: 20px;
}

.package-details {
	list-style: none;
	padding: 0;
	margin: 0;
}

.package-details li {
	font-size: 14px;
}
.page-loading {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
}
.not-found-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 200px; /* Adjust as necessary */
}
</style>
